/** Media-run figures. Absence is never zero: anything not a finite number prints as a dash. */
import type { MediaPlanView, VideoSample } from './api';

const ok = (v: unknown): v is number => typeof v === 'number' && Number.isFinite(v);
export const num = (v: unknown) => (ok(v) ? String(v) : '—');
export const secs = (v: unknown) => (ok(v) ? `${v.toFixed(2)} s` : '—');
export const bytes = (v: unknown) => (!ok(v) ? '—' : v >= 1e9 ? `${(v / 1e9).toFixed(2)} GB` : `${(v / 1e6).toFixed(1)} MB`);
/** k6 Rates arrive as 0..1; show them as a percent. */
export const pct = (v: unknown) => (ok(v) ? `${(v * 100).toFixed(1)}%` : '—');
export const stalledShare = (v: VideoSample) => pct(v.stalledSegments);

/** Approval-card lines for a media plan: the viewers, bitrate and every limit the run will be held to. */
export function mediaPlanLines(p: MediaPlanView): string[] {
  const t = p.thresholds, w = p.workload;
  return [
    `Stages ${w.stages.map((s) => `${s.duration} → ${s.viewers} viewers`).join(', ')}; max ${w.max_vus} viewers; bitrate ${(w.bitrate_bps / 1e6).toFixed(2)} Mb/s`,
    `Thresholds errors ${pct(t.error_rate)}, segment errors ${pct(t.segment_error_rate)}, start p95 ${t.start_p95_s} s, rebuffer ${pct(t.rebuffer_ratio)}, stalled ${pct(t.stalled_segment_rate)}, session failures ${pct(t.session_failure_rate)}`,
    `Abort at p95 ×${p.abort.p95_vs_baseline}, 5xx ${pct(p.abort.error_rate)}, segment p95 ${p.abort.segment_p95_s} s, PeerTube CPU ${p.abort.peertube_cpu}`,
  ];
}
